import HistoricalArbitrageOrderInquiry from './historical-arbitrage-order-inquiry.vue'
export default HistoricalArbitrageOrderInquiry
